module.exports = __webpack_public_path__ + "static/media/sharing-banner.8afc7742.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/sharing-banner.png
// module id = 571
// module chunks = 0